import axios from "@/plugins/axios";
export default {
  data() {
    return {
      rules: {
        A: {
          name: "Waterfall",
          desc:
            "Each player starts drinking at the same time as the person to their left. NO player can stop drinking until the person before them stops."
        },
        2: {
          name: "You",
          desc: "Whoever draws this can choose anyone to take a drink."
        },
        3: {
          name: "Me",
          desc: "The person who draws this takes a drink."
        },
        4: {
          name: "Floor",
          desc: "The last person to touch the floor takes a drink."
        },
        5: {
          name: "Guys",
          desc: "All the guys at the table drink."
        },
        6: {
          name: "Chicks",
          desc: "All the girls at the table drink."
        },
        7: {
          name: "Heaven",
          desc:
            "If you draw this card, raise your hand above you head. Every other player must do so as well. The last person takes a drink."
        },
        8: {
          name: "Mate",
          desc:
            "Choose someone to be your mate. For the rest of the game, they drink when you drink."
        },
        9: {
          name: "Rhyme",
          desc:
            "You say a word, then the person to your right has to say a word that rhymes. This continues until someone can't think of a word. That person takes a drink. You can't reuse words."
        },
        10: {
          name: "Categories",
          desc:
            "Come up with a category of things. The person to your right must name something that falls within the category. This continues until someone can't think of something. That person takes a drink"
        },
        J: {
          name: "Never Have I Ever",
          desc: "Never Have I Ever."
        },
        Q: {
          name: "Questions",
          desc:
            "Ask someone a question. That person then asks someone else a question. This continues until someone messes up or fails to ask a question. That person drinks. No question can be repeated."
        },
        K: {
          name: "King's Cup",
          desc:
            "Set a rule to be followed, e.g. stand on one foot when you drink, only speak in an accent, etc."
        }
      },
      cards: [
        //spade
        ["🂡", "🂢", "🂣", "🂤", "🂥", "🂦", "🂧", "🂨", "🂩", "🂪", "🂫", "🂭", "🂭", "🂮"],
        //hearts
        ["🂱", "🂲", "🂳", "🂴", "🂵", "🂶", "🂷", "🂸", "🂹", "🂺", "🂻", "🂽", "🂽", "🂾"],
        //diamond
        ["🃁", "🃂", "🃃", "🃄", "🃅", "🃆", "🃇", "🃈", "🃉", "🃊", "🃋", "🃍", "🃍", "🃎"],
        //clubs
        ["🃑", "🃒", "🃓", "🃔", "🃕", "🃖", "🃗", "🃘", "🃙", "🃚", "🃛", "🃝", "🃝", "🃞"]
      ]
    };
  },
  computed: {
    card() {
      if (this.currentCard != null) {
        const { rank, suit } = this.currentCard.card;
        let faceIndexMap = { A: 0, J: 10, Q: 11, K: 12 };
        let rankIndex = !isNaN(rank) ? parseInt(rank) - 1 : faceIndexMap[rank];
        const suitIndexMap = { Spades: 0, Hearts: 1, Clubs: 2, Diamonds: 3 };
        let suitIndex = suitIndexMap[suit];
        if (suitIndex != undefined && rankIndex != undefined) {
          return this.cards[suitIndex][rankIndex];
        }
      }
      return "🃟";
    },
    currentCard() {
      const { kingscup } = this;
      if (
        kingscup != undefined &&
        kingscup.drawn_cards != undefined &&
        kingscup.drawn_cards.length > 0
      ) {
        const { rank, suit } = this.kingscup.drawn_cards[0];
        return {
          rule: this.rules[rank],
          card: { rank, suit }
        };
      }
      return null;
    }
  },
  methods: {
    async joinGame(gameId) {
      let url = `/api/kingscup/${gameId}`;
      try {
        const { data } = await axios.put(url);
        console.log(data);
      } catch {
        //
      }
    }
  }
};
